"use client";

import { ArrowLeft } from "lucide-react";
import Link from "next/link";

import { Button } from "@/components/ui/button";
import { ZomMark } from "@/components/ui/ZomMark";
import { cn } from "@/lib/utils";
import SupportTicketSection from "./sections/SupportTicketSection";
import { getSupportTone } from "./supportTheme";

export default function SupportPage() {
  const tone = getSupportTone(true);

  return (
    <div
      className={cn(
        "font-body relative min-h-screen overflow-x-hidden",
        tone.page,
      )}
    >
      <header className="relative z-10 border-b border-[color:var(--zom-public-white-hairline)] bg-[color:var(--zom-public-white-wash)]">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between px-5 sm:px-8">
          <Link
            href="/"
            className="flex items-center gap-2 text-[color:var(--zom-public-white)]"
            aria-label="Zom home"
          >
            <ZomMark variant="dark" size={18} alt="" />
            <span className="text-[17px] font-semibold tracking-[-0.02em]">
              Zom
            </span>
            <span className="text-[13px] text-[color:var(--zom-public-white-subtle)]">
              Support
            </span>
          </Link>
          <Button
            asChild
            variant="ghost"
            size="sm"
            className="text-[color:var(--zom-public-white-muted)] hover:bg-[color:var(--zom-public-white-wash)] hover:text-[color:var(--zom-public-white)]"
          >
            <Link href="/ai-chat">
              <ArrowLeft className="h-3.5 w-3.5" aria-hidden />
              Return to workspace
            </Link>
          </Button>
        </div>
      </header>

      <main className="relative">
        <SupportTicketSection tone={tone} isDark />
      </main>
    </div>
  );
}
